export const typography = {
  fontFamilies: {
    dmSans: 'DM Sans, sans-serif',
    inter: 'Inter, sans-serif'
  },
  heading: {
    xl: { lineHeight: 1.3 },
    lg: { lineHeight: 1.3 },
    md: { lineHeight: 1.3 },
    sm: { lineHeight: 1.3 }
  },
  body: {
    lg: { lineHeight: 26 },
    sm: { lineHeight: 20 }
  }
};
